import { NgClass } from '@angular/common'
import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  effect,
  input,
  output,
  viewChild,
} from '@angular/core'
import { MatCardModule } from '@angular/material/card'
import { MatSort, MatSortModule, Sort } from '@angular/material/sort'
import { MatTableDataSource, MatTableModule } from '@angular/material/table'

import { TranslateModule } from '@ngx-translate/core'
import { get } from 'lodash-es'

import { APP_DEFAULT_LANGUAGE } from '~/core/constants'
import { ELanguage, EPerformanceSummaryFlag, IPerformanceCntEst } from '~/core/models'
import { CompactNumber } from '~/shared/pipes'

import { ANALYST_COVERAGE_COLUMNS, DISPLAYED_COLUMNS } from '../../analyst-coverage-tab.constant'

@Component({
  selector: 'app-win-rates-by-cnt-est',
  templateUrl: './win-rates-by-cnt-est.component.html',
  styleUrl: './win-rates-by-cnt-est.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgClass, MatCardModule, MatSortModule, CompactNumber, MatTableModule, TranslateModule],
})
export class WinRatesByCntEstComponent implements AfterViewInit {
  readonly lang = input<ELanguage>(APP_DEFAULT_LANGUAGE)
  readonly performanceCntEstData = input<IPerformanceCntEst[]>([])
  readonly performanceCntEstTotal = input<IPerformanceCntEst | null>(null)
  readonly sortBy = input<string>('')
  readonly order = input<'asc' | 'desc' | ''>('')

  readonly changeSort = output<{
    sortBy: string
    order: 'asc' | 'desc' | ''
  }>()

  readonly matSort = viewChild(MatSort)

  get = get
  performanceSummaryFlag = EPerformanceSummaryFlag
  ANALYST_COVERAGE_COLUMNS = ANALYST_COVERAGE_COLUMNS
  DISPLAYED_COLUMNS = DISPLAYED_COLUMNS
  dataSource = new MatTableDataSource<IPerformanceCntEst>([])
  orderBy = ''
  orderDirection: 'asc' | 'desc' | '' = ''

  constructor() {
    effect(() => {
      this.dataSource = new MatTableDataSource<IPerformanceCntEst>(this.performanceCntEstData())
    })

    effect(() => {
      this.orderBy = this.sortBy()
    })

    effect(() => {
      this.orderDirection = this.order()
    })
  }

  ngAfterViewInit(): void {
    const matSort = this.matSort()

    if (matSort) {
      this.dataSource.sort = matSort
    }
  }

  sortChange(sort: Sort): void {
    this.orderBy = sort.direction ? sort.active : ''
    this.orderDirection = sort.direction

    this.changeSort.emit({
      sortBy: this.orderBy,
      order: this.orderDirection,
    })
  }

  getTotalValue(name: string): any {
    const performanceCntEstTotal = this.performanceCntEstTotal()

    return performanceCntEstTotal && name in performanceCntEstTotal
      ? (performanceCntEstTotal as any)[name]
      : ''
  }
}
